import api from '../api'

export default {
    namespaced: true,
    state: {
        clubList: {// 俱乐部列表
            beanList: [],
            total: 0,
        },
        clubDetail: {// 俱乐部详情
            info: null,
            beanList: [],
            total: 0
        },
        hotClubList: {// 推荐俱乐部列表
            beanList: [],
            total: 0,
        },
        canSetHotClub: {
            beanList: [],
            total: 0,
        },
        clubPromoteList: {// 俱乐部推广记录查询
            beanList: [],
            total: 0,
            totalDownTimes: 0,
            totalRegTimes: 0,
            totalViewTimes: 0,
        }
    },
    mutations: {
        setStateClubList(state, info) {
            state.clubList = info;
        },
        setStateClubDetail(state, info) {
            state.clubDetail = Object.assign({}, state.clubDetail, {
                info: info.infoBean,
                beanList: info.userBeanList.beanList,
                total: info.userBeanList.total
            });
        },
        setStateHotClubList(state, info) {
            state.hotClubList = info;
        },
        setStateCanSetHotClub(state, info) {
            state.canSetHotClub = info;
        },
        setStateClubPromoteList(state, info) {
            let {pageInfo, ...other} = info;
            state.clubPromoteList = {
                ...pageInfo, ...other
            };
        },
    },
    actions: {
        getClubList({commit}, params) {
            return api.post('/club/search', '查找俱乐部', params).then(res => {
                commit('setStateClubList', res.data)
                return res.data
            })
        },
        getClubDetail({commit}, {clubId, ...params}) {
            return api.post(`/club/clubInfoDetail/${clubId}`, '俱乐部详细', params).then(res => {
                commit('setStateClubDetail', res.data)
            })
        },
        updateClubConfig(store, {clubId, ...params}) {
            return api.post(`/club/updateClubIdInfo/${clubId}`, '修改俱乐部信息', params)
        },
        updateRebateConfig(store, {clubId, ...params}) {
            return api.post(`/club/updateRebateConfig/${clubId}`, '修改俱乐部对赌信息', params)
        },

        updateClubRandomId(store, params) {
            return api.post(`/club/updateClubRandomId`, '修改俱乐部显性id', params)
        },
        getHotClubList({commit}, params) {
            return api.post(`/club/hotClubList`, '推荐的俱乐部列表', params).then(res => {
                commit('setStateHotClubList', res.data)
            })
        },
        updateHotClub(store, params) {
            return api.post(`/club/setHotClubPosition/${params.id}/${params.op}`, '调整推荐俱乐部的位置')
        },
        addHotClub(store, params) {
            return api.post(`/club/addHotClubList`, '添加推荐俱乐部', params)
        },
        deleteHotClub(store, params) {
            return api.post(`/club/delHotClubList`, '删除推荐俱乐部', params)
        },
        getCanSetHotClub({commit}, params) {
            return api.post(`/club/searchClubList`, '可推荐俱乐部列表', params).then(res => {
                commit('setStateCanSetHotClub', res.data)
            })
        },
        getClubPromoters(store, params) {
            return api.post(`/club/join/search/promotors`, '根据俱乐部id查询俱乐部推广员列表', params)
        },
        batchJoinClub(store, params) {
            return api.post(`/club/join/batch/join/club`, '批量加入俱乐部', params)
        },
        getClubPromoteList({commit}, params) {
            return api.post('/club/clubPromoteList', '俱乐部推广记录查询', params).then(res => {
                commit('setStateClubPromoteList', res.data)
            })
        }
    }
}